const filteredBugsnagErrorMessages = [
  'globalThis',
  'ResizeObserver',
  'https://git.io/JUIaE#17',
  'Network Error',
  'Request aborted',
  'notify() received a non-error.'
];

export default filteredBugsnagErrorMessages;
